import * as React from 'react';
import classNames from 'classnames';
import ArticleCard, { IArticleCardProps } from '@/components/ui/ArticleCard';

const CarouselPost: React.FunctionComponent<IArticleCardProps> = (props) => (
  <div className={classNames('carousel__item', 'carousel__item-post')}>
    <ArticleCard {...props} />
  </div>
);

CarouselPost.displayName = 'CarouselOpinion';

export default CarouselPost;
